import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import {
  OnboardingProfilesIcon,
  ClassificationApplicantsTypesIcon,
  TypesOfPublicationFormatsIcon,
  TypesOfPublicationChannelsIcon,
  TypesOfOnboardingActionsIcon,
  OnboardingMaterialsIcon,
} from "@icarius-icons/";
import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

const Index = () => {

  const data = [
    {
      name: getLocalizedString("classificationApplicantsTypes"),
      icon: <ClassificationApplicantsTypesIcon />,
      path: paths.classificationApplicantsTypes,
    },
    {
      name: getLocalizedString("typesOfPublicationChannels"),
      icon: <TypesOfPublicationChannelsIcon />,
      path: paths.typesOfPublicationChannels,
    },
    {
      name: getLocalizedString("typesOfPublicationFormats"),
      icon: <TypesOfPublicationFormatsIcon />,
      path: paths.typesOfPublicationFormats,
    },
    {
      name: getLocalizedString("typesOfOnboardingActions"),
      icon: <TypesOfOnboardingActionsIcon />,
      path: paths.typesOfOnboardingActions,
    },
    {
      name: getLocalizedString("onboardingMaterials"),
      icon: <OnboardingMaterialsIcon />,
      path: paths.onboardingMaterials,
    },
    {
      name: getLocalizedString("onboardingStageProfiles"),
      icon: <OnboardingProfilesIcon />,
      path: paths.onboardingProfiles,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("talentAcquisitionSettings")}
      data={data}
    />
  );
}

export default Index;
